import "./exercise-type.scss"
import { EXERCISE_TYPE_FILTERS, EXERCISE_TYPE_LABELS } from "../../../data-utils/exerciseType"

// Segmented "Type: All · CTF · Training · Assessment" control with counts (CTF reports spec §6).
// `counts` = { all, ctf, training, assessment } (omit to hide the numbers). `value` null = All.
// `includeCtf` false drops the CTF segment (orgs without the CTF entitlement and no CTF exercises).
const ExerciseTypeFilter = ({ value = null, counts = null, onChange, className = "", label = "Exercise type", includeCtf = true }) => {
  const options = [{ key: null, label: "All", count: counts?.all }].concat(
    EXERCISE_TYPE_FILTERS.filter((key) => includeCtf || key !== "ctf").map((key) => ({ key, label: EXERCISE_TYPE_LABELS[key], count: counts?.[key] }))
  )
  const selectedIndex = Math.max(
    0,
    options.findIndex((opt) => (opt.key ?? null) === (value ?? null))
  )
  // Radio-group keyboard behaviour (buttons don't get it from the browser): arrows move AND select,
  // Home/End jump, and only the selected option is a tab stop.
  const onKeyDown = (event) => {
    const step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key]
    let next = null
    if (step) next = (selectedIndex + step + options.length) % options.length
    else if (event.key === "Home") next = 0
    else if (event.key === "End") next = options.length - 1
    if (next == null) return
    event.preventDefault()
    onChange?.(options[next].key)
    event.currentTarget.querySelectorAll('[role="radio"]')[next]?.focus()
  }
  return (
    <div className={`ct-type-seg ${className}`.trim()} role="radiogroup" aria-label={label} onKeyDown={onKeyDown}>
      {options.map((opt, index) => {
        const on = index === selectedIndex
        return (
          <button
            key={opt.key ?? "all"}
            type="button"
            role="radio"
            aria-checked={on}
            tabIndex={on ? 0 : -1}
            className={on ? "on" : ""}
            data-type-filter={opt.key ?? "all"}
            onClick={() => onChange?.(opt.key)}
          >
            {opt.key === "ctf" ? <span aria-hidden="true">{"⚑"}</span> : null}
            <span>{opt.label}</span>
            {typeof opt.count === "number" ? <span className="n">{opt.count}</span> : null}
          </button>
        )
      })}
    </div>
  )
}

export default ExerciseTypeFilter
